
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Tooltip extends Vue {
  @Prop() text!: string;
  @Prop({ required: true }) width!: string;
  @Prop({ required: true }) height!: string;
  @Prop({ required: true }) left!: string;
  @Prop({ required: true }) top!: string;
  @Prop({ default: false }) upArrow!: boolean;

  private styleTooltip = {
    width: this.width,
    left: this.left,
    top: this.top,
    height: this.height
  };

  get _text() {
    return this.text || String(this.$t('tooltipComponents.defaultText'));
  }

}
